import { memo } from "react";
import { Flex, Text, Button, useMantineTheme } from "@mantine/core";
import { BsPersonLinesFill } from "react-icons/bs";
import { getTimeInAMPMFormat } from "src/utils/dateHelper";
import { GetCheckInOneQuery } from "src/generated/graphql";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/utils/constants";

type IHeader = {
  checkInDetail: GetCheckInOneQuery["checkInOne"];
};

function Header({ checkInDetail }: IHeader) {
  const navigate = useNavigate();
  const { client } = checkInDetail || {};
  const theme = useMantineTheme();
  let color = theme.colors.secondaryTextColor[6];

  const handleViewProfile = () => {
    navigate(`${ROUTES.CLIENT}/${client?.id}`);
  };

  return (
    <Flex
      justify={"space-between"}
      sx={{
        borderBottom: `1px solid ${theme.colors.secondary[0]}`,
        color,
      }}
      p={"4px 0"}
      mb={"sm"}
    >
      <Text fw={500} size={22}>
        {getTimeInAMPMFormat(new Date(checkInDetail?.createdDate))}
      </Text>

      <Text fw={500} size={24}>
        {client?.user.firstName} {client?.user.lastName}
      </Text>

      <Button
        radius="xl"
        size="xs"
        sx={{
          background: theme.colors.primary[6],
          color: theme.colors.primaryTextColor[6],
          "&:hover": {
            background: theme.colors.primary[4],
          },
        }}
        leftIcon={<BsPersonLinesFill />}
        variant="white"
        onClick={handleViewProfile}
      >
        View Profile
      </Button>
    </Flex>
  );
}

export default memo(Header);
